import React from 'react';
import ReactDOM from 'react-dom/client';
import { ColorModeProvider } from './styles/ColorModeProvider';
import App from './App';
import { NotificacionProvider } from './componentes/common/NotificacionContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <NotificacionProvider>
    <React.StrictMode>
      <ColorModeProvider>
        <App />
      </ColorModeProvider>
    </React.StrictMode>
  </NotificacionProvider>
);